import React from 'react';
import classNames from 'classnames';

export const AddChoiceButton = ({
  className,
  ...props
}: React.ComponentProps<'button'>) => {
  return (
    <button
      className={classNames(
        'bg-[#fbfbfb] flex items-center justify-center w-full ml-0 mb-2.5 mt-0 p-[5px] border border-dashed border-[#d5d5d5] rounded-[5px] text-[#96a9a7] text-sm',
        className
      )}
      {...props}
    />
  );
};
